import { Component } from "@angular/core";
import { IHeaderAngularComp } from "ag-grid-angular";
import { IHeaderParams } from "ag-grid-community";

/**
 * Select-all header for MAM Explorer infinite scroll.
 * Selects / deselects only rows already loaded in the grid (no page menu).
 */
@Component({
  selector: "evrideo-mam-explorer-select-all-header",
  templateUrl: "./mam-explorer-select-all-header.component.html",
  styleUrls: ["./mam-explorer-select-all-header.component.scss"],
})
export class MamExplorerSelectAllHeaderComponent
  implements IHeaderAngularComp
{
  isChecked = false;
  isIndeterminate = false;
  private params: IHeaderParams;

  refresh(): boolean {
    return false;
  }

  agInit(params: IHeaderParams): void {
    this.params = params;
    this.params.api.addEventListener("selectionChanged", () => {
      this.setCheckboxState();
    });
  }

  toggleSelect(): void {
    if (this.isChecked) {
      this.params.api.forEachNode((node) => {
        if (node.data) {
          node.setSelected(true);
        }
      });

      const event: any = {
        type: "selectionChanged",
        api: this.params.api,
        columnApi: (this.params as any).columnApi,
      };
      (this.params.api as any).eventService?.dispatchEvent(event);
    } else {
      this.params.api.deselectAll();
    }
  }

  private setCheckboxState(): void {
    const selectedNodesLength = this.params.api.getSelectedNodes()?.length ?? 0;
    let loadedNodesWithData = 0;
    this.params.api.forEachNode((node) => {
      if (node.data) {
        loadedNodesWithData++;
      }
    });

    this.isChecked =
      selectedNodesLength > 0 &&
      selectedNodesLength === loadedNodesWithData;
    this.isIndeterminate = selectedNodesLength > 0 && !this.isChecked;
  }
}
